module.exports = __webpack_public_path__ + "static/media/video.9bbb9e38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Picton/video.jpg
// module id = 307
// module chunks = 0